import Stack from '@mui/material/Stack';

const ProviderImage = ({provider}) => (
  <Stack alignItems='center' justifyContent='center' className='ViewProvider__profile__photo'>
    <img
      src={provider.imgSrc}
      alt={`${provider.firstName} ${provider.lastName} MovementX physical therapist in ${provider.primary_location} headshot`}
      loading="lazy"
      width='100%'
    />
  </Stack>
);

export default ProviderImage;
